import { registerScopedPriceCache } from "./priceCacheScope";

const cache = registerScopedPriceCache(new Map());

export const factorPriceCacheKey = ({
  projectId,
  insurancePlanId,
  partnerCode,
  source,
  factors,
}) =>
  JSON.stringify([
    projectId,
    insurancePlanId,
    partnerCode || "",
    source,
    factors || {},
  ]);

export const readFactorPriceCache = (key) => cache.get(key);

export const writeFactorPriceCache = (key, value) => {
  cache.set(key, value);
  return value;
};

export const clearFactorPriceCache = () => {
  cache.clear();
};
